import { init, setKeyMap } from '@noriginmedia/norigin-spatial-navigation';

// 电视平台键码常量
export const TV_KEY_CODES = {
  // 标准方向键
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  ENTER: 13,

  // 返回键
  BACKSPACE: 8,
  ESC: 27,
  SAMSUNG_RETURN: 10009,
  LG_BACK: 461,

  // 快进/快退
  REWIND_227: 227,
  REWIND_119: 119,
  FAST_FWD_228: 228,
  FAST_FWD_118: 118,

  // 媒体控制
  PAUSE_19: 19,
  PAUSE_413: 413,
  PAUSE_169: 169,
  PLAY_415: 415,
  PLAY_179: 179,
  PLAY_PAUSE_116: 116,
  STOP_117: 117,

  // 获取全局 VK 键码（如果存在）
  get VK_BACK() {
    return (window as any).VK_BACK;
  },
  get VK_UP() {
    return (window as any).VK_UP;
  },
  get VK_DOWN() {
    return (window as any).VK_DOWN;
  },
  get VK_LEFT() {
    return (window as any).VK_LEFT;
  },
  get VK_RIGHT() {
    return (window as any).VK_RIGHT;
  },
  get VK_ENTER() {
    return (window as any).VK_ENTER;
  },
  get VK_PLAY() {
    return (window as any).VK_PLAY;
  },
  get VK_PAUSE() {
    return (window as any).VK_PAUSE;
  },
  get VK_STOP() {
    return (window as any).VK_STOP;
  },
  get VK_REWIND() {
    return (window as any).VK_REWIND;
  },
  get VK_FAST_FWD() {
    return (window as any).VK_FAST_FWD;
  },
  get VK_PLAY_PAUSE() {
    return (window as any).VK_PLAY_PAUSE;
  },
} as const;

// 初始化空间导航
export const initSpatialNavigation = () => {
  init({
    debug: process.env.NODE_ENV === 'development', // 仅在开发环境启用调试
    throttle: 16, // TV兼容性优化，减少键盘事件触发频率
    // visualDebug: false, // 可视化调试，生产环境关闭
  });

  // 收集所有方向键和确认键的键码
  const leftKeys = [
    TV_KEY_CODES.ARROW_LEFT,
    TV_KEY_CODES.REWIND_227,
    TV_KEY_CODES.REWIND_119,
    TV_KEY_CODES.VK_LEFT,
    TV_KEY_CODES.VK_REWIND,
  ].filter((key) => key !== undefined);

  const upKeys = [TV_KEY_CODES.ARROW_UP, TV_KEY_CODES.VK_UP].filter((key) => key !== undefined);

  const rightKeys = [
    TV_KEY_CODES.ARROW_RIGHT,
    TV_KEY_CODES.FAST_FWD_228,
    TV_KEY_CODES.FAST_FWD_118,
    TV_KEY_CODES.VK_RIGHT,
    TV_KEY_CODES.VK_FAST_FWD,
  ].filter((key) => key !== undefined);

  const downKeys = [TV_KEY_CODES.ARROW_DOWN, TV_KEY_CODES.VK_DOWN].filter((key) => key !== undefined);

  const enterKeys = [TV_KEY_CODES.ENTER, TV_KEY_CODES.VK_ENTER].filter((key) => key !== undefined);

  // 设置按键映射（支持多个键码）
  setKeyMap({
    left: leftKeys,
    up: upKeys,
    right: rightKeys,
    down: downKeys,
    enter: enterKeys,
  });
};

// 焦点样式配置
export const FocusStyles = {
  default: {
    border: '3px solid #00a8ff',
    boxShadow: '0 0 20px rgba(0, 168, 255, 0.6)',
    transform: 'scale(1.05)',
    transition: 'all 0.2s ease-in-out',
  },
  button: {
    backgroundColor: '#00a8ff',
    color: '#fff',
    transform: 'scale(1.1)',
    boxShadow: '0 0 20px rgba(0, 168, 255, 0.8)',
  },
  card: {
    border: '3px solid #00a8ff',
    transform: 'scale(1.08)',
    boxShadow: '0 0 25px rgba(0, 168, 255, 0.7)',
  },
};
